import { Component, OnInit, HostBinding, ElementRef } from '@angular/core';

import { ContainerViewModel } from '../../types/control.types';
import { ControlTypeName } from '../../types/control-type-name';
import { AbstractControlContainerComponent } from '../abstract-control-container/abstract-control-container.component';

@Component({
  // tslint:disable-next-line: component-selector
  selector: '[dy-cell]',
  templateUrl: './cell.component.html',
  styleUrls: ['./cell.component.css']
})
export class CellComponent extends AbstractControlContainerComponent<ContainerViewModel> implements OnInit {
  type: string = ControlTypeName.cell;
  isDesign: boolean = false;
  model: ContainerViewModel;

  @HostBinding()
  get class(): string {
    let className = '';
    if (!this.isDesign) {
      className = this.getClass() + ' dy-cell';
    } else {
      className = '  design dy-cell';
    }

    return className + this.hiddenClass;
  }

  get designHostClass(): string {
    return this.getClass();
  }

  private getClass(): string {
    let c = this.model ? this.model.class : '';
    c = c ? c : '';
    c = c + ` col-sm`;
    if (this.model.columnLength) {
      c = c + `-` + this.model.columnLength;
    }
    return c;
  }

  constructor() {
    super();
  }

  ngOnInit() {}
}
